import NmiChange from "../js/components/groupManagement/NmiChange.react";
export default NmiChange;
